import { useContext } from 'react';
import { ToastContext } from '../contexts/toast-notification-context';
import { ToastContextProps } from '../types/toast-notification';

const useToastNotification = (): ToastContextProps => {
    const context = useContext(ToastContext);

    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }

    return context;
};

export default useToastNotification;
